import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import FormStatic from "./FormStatic";
import { Data } from "../App";

export default function Confirm() {
  const { formData, selectedList } = useContext(Data);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  function sendForm() {
    const ua = navigator.userAgent.match(/iPhone|Android.+Mobile/)
      ? "スマートフォン"
      : "インターネット";
    const sendData = {
      ...formData,
      message: JSON.stringify(formData.message),
      ua: ua,
    };
    fetch(`/material/sample/form/sampleform.php?cb=${Date.now()}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          navigate("/form/thanks/", { replace: true });
        } else if (data.status === "error") {
          alert(data.message);
          navigate(-1);
        } else {
          alert("Unexpected Error");
          navigate(-1);
        }
      })
      .catch((error) => {
        alert(error);
        navigate(-1);
      });
  }

  return (
    <>
      <Helmet>
        <title>入力確認 | 生地サンプル請求 | 国産ソファブランド NOYES</title>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
        />
      </Helmet>
      <div className="form_wrapper">
        <FormStatic selectedList={selectedList} />
        <h3>
          <b>お名前</b>
        </h3>
        <dl className="form_common">
          <dt>
            <b>漢字</b>
            <b className="required">必須</b>
          </dt>
          <dd>
            <span>姓　</span>
            <div className="inputConfirm">{formData.lastname}</div>
            <span>名　</span>
            <div className="inputConfirm">{formData.name}</div>
          </dd>
          <dt>
            <b>ふりがな</b>
            <b className="required">必須</b>
          </dt>
          <dd>
            <span>せい</span>
            <div className="inputConfirm">{formData.furigana1}</div>
            <span>めい</span>
            <div className="inputConfirm">{formData.furigana2}</div>
          </dd>
        </dl>

        <h3>
          <b>生地サンプルお届け先</b>
        </h3>
        <dl>
          <dt>
            <b>郵便番号</b>
            <b className="required">必須</b>
          </dt>
          <dd className="col">
            <div className="inputConfirm">{formData.post}</div>
          </dd>
          <dt>
            <b>都道府県</b>
            <b className="required">必須</b>
          </dt>
          <dd className="col">
            <div className="inputConfirm">{formData.pref}</div>
          </dd>
          <dt>
            <b>市区町村</b>
            <b className="required">必須</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.address1}</div>
          </dd>
          <dt>
            <b>番地・建物名</b>
            <b className="required">必須</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.address2}</div>
          </dd>
          <dt>
            <b>メールアドレス</b>
            <b className="required">必須</b>
          </dt>
          <dd className="col">
            <p>ご入力いただいたアドレスに受付確認メールをお送りいたします</p>
            <div className="inputConfirm">{formData.email}</div>
            <p>確認のため再度ご入力ください</p>
            <div className="inputConfirm">{formData.emailcheck}</div>
          </dd>
        </dl>

        <h3>
          <b>アンケート</b>
        </h3>
        <dl className="form_enquate">
          <dt>
            <b>生地請求は初めてですか？</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.enquate1}</div>
          </dd>
          <dt>
            <b>ご検討ソファ</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.enquate2}</div>
          </dd>
          <dt>
            <b>ご購入時期</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.enquate3}</div>
          </dd>
          <dt>
            <b>年齢</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.enquate4}</div>
          </dd>
          <dt>
            <b>住宅環境</b>
          </dt>
          <dd>
            <div className="inputConfirm">{formData.enquate5}</div>
          </dd>
          <dt>
            <b>ご意見・ご要望等ございましたらご記入ください</b>
          </dt>
          <dd>
            <div className="textareaConfirm">{formData.message}</div>
          </dd>
        </dl>

        <dl>
          <dt>メールマガジン購読</dt>
          <dd className="col">
            <div className="inputConfirm">{formData.mm}</div>
          </dd>
        </dl>

        <div className="btnFlex">
          <button
            className="formBtn"
            onClick={() => navigate(-1)}
            style={{ backgroundColor: "#EBEBEB" }}
          >
            <b style={{ color: "#000000" }}>内容を修正</b>
          </button>

          <button className="formBtn" onClick={() => sendForm()}>
            <b>送信</b>
          </button>
        </div>
      </div>
    </>
  );
}
